export const environment = {
  production: true,
  buildId: '2567219450317701',
  configFile: 'config.json',
};
